import React, { useEffect, useState } from 'react'
import { ParallaxProvider } from 'react-scroll-parallax';
import { useDispatch, useSelector } from 'react-redux'
import { ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router';

import { LOCATION_NAME_MAP, parseTheme } from '../../utils/common';
import Header from './Header';
import Loader from './Loaders/Loader';
import Sidebar from './Sidebar';

import useWindowDimensions from '../../hooks/UseWindowDimensions';
import { revertToAdminSession } from '../../../features/session/sessionSlice';
import OnboardingFooter from './OnboardingFooter';

function AuthContainer(props){
    const dispatch = useDispatch()

    const theme = parseTheme()
    const location = useLocation();
    const { width } = useWindowDimensions()

    const [ parallaxDisabled, setParallaxDisabled ] = useState(false)
    useEffect(() => {
        document.title = `${LOCATION_NAME_MAP[location.pathname] ? (LOCATION_NAME_MAP[location.pathname] + " - ") : ""}${theme?.title ?? "The Insights Engine"}`
    }, [location]);

    useEffect(() => {
        if(width < 992 && !parallaxDisabled){
            setParallaxDisabled(true)
        } else if(width >= 992 && parallaxDisabled){
            setParallaxDisabled(false)
        }
    }, [width])

    const sessionStatus = useSelector(state => state.session.status)
    const onboardingInProgress = useSelector(state => state.session.onboardingInProgress)
    const showSidebar = useSelector(state => state.session.showSidebar)
    const adminSession = useSelector(state => state.session.adminSession)
    const user = useSelector(state => state.session.user)
    const showHeader = useSelector(state => state.session.showHeader)
    const useDarkMode = useSelector(state => state.session.useDarkMode)

    const siteStatus = useSelector(state => state.site.status)

    return <Loader type='spin' color='#000000' isLoading={(sessionStatus === "loading" || siteStatus === "initialLoading")}>
        {showHeader && <Header />}
        {showSidebar && <Sidebar />}
        {(!showSidebar && adminSession !== null) && <div className="text-center rounded p-20 bg-white" style={{
            position: "fixed",
            top: "15%",
            left: "20px"
        }}>
            <h4>Logged In as:</h4>
            <h5>{ user?.given_name } { user?.family_name }</h5>
            <button className="btn btn-danger mb-3" onClick={() => dispatch(revertToAdminSession())}>
                <i class="fas fa-user-secret"></i> Remove Disguise
            </button>
        </div>}
        <ToastContainer
            containerId="defaultToastContainer"
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
            />
        {/* <div style={{
            backgroundColor: `rgb(36, 68, 127, ${useDarkMode ? "0.5" : "1"})`,
            borderRadius: "0% 0% 50% 50%/0% 0% 12vh 12vh",
            position: "fixed",
            width: "100%",
            minHeight: "55vh",
            overflowX: "hidden"
         }}></div> */}
        <div id="content" className={"content"} style={onboardingInProgress ? {
            marginLeft: "0px",
            position: "relative"
        } : {
            position: "relative"
        }}>
            {props.children}
        </div>
        {onboardingInProgress && <OnboardingFooter />}
    </Loader>
}

export default AuthContainer